import { htmlFontSize } from "./base"

export const typography = {
  color: "#333333",
  fontFamily: "'Open Sans Eas', 'Open Sans', sans-serif",
  htmlFontSize,
}
